import { render } from "./ProductManagement.vue?vue&type=template&id=935f87c2&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"

import "./ProductManagement.vue?vue&type=style&index=0&id=935f87c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-935f87c2"

export default script